import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}

// jwtToken
const getJwtToken = () => {
    const raw = sessionStorage.getItem("clinic-application-jwt") || localStorage.getItem("clinic-application-jwt");
    const userData = JSON.parse(raw);
    return "Bearer " + String(userData.token);
};


export const PostIsShown = createAsyncThunk(
  "appointments/updateIsShown",
  async ({ appointmentId, isShown }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${END_POINT}/appointment/isShown/${appointmentId}`, { isShown }, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


